import Modal from "@mui/material/Modal";
import { CloseButton, CloseButtonWrapper } from "../style/modalStyle";
import { CrossIcon } from "../../assets/Icon/ModalIcon";

interface ModalPropType {
  open: boolean;
  handleClose: () => void;
  img: any;
}

export default function PreviewModal({ open, handleClose, img }: ModalPropType) {
  const lowerImg = typeof img === "string" ? img.toLowerCase() : "";
  const isPDF = lowerImg.endsWith(".pdf");
  const isDoc = lowerImg.endsWith(".doc") || lowerImg.endsWith(".docx");
  const encodedURL = encodeURIComponent(img ?? "");
  const viewerURL = isDoc
    ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodedURL}`
    : isPDF
    ? img
    : "";
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(5px)", 
      }}
    >
      <div
        style={{
          width: isPDF || isDoc ? "90vw" : "80vw", 
          maxWidth: isPDF || isDoc ? "1200px" : "900px", 
          height: isPDF || isDoc ? "85vh" : "70vh", 
          backgroundColor: "rgba(0, 0, 0, 0.9)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "10px",
          position: "relative",
          padding: "10px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)",
        }}
      >
   
        <CloseButtonWrapper
          style={{ position: "absolute", top: 10, right: 10, zIndex: 10 }}
        >
          <CloseButton onClick={handleClose}>
            <CrossIcon />
          </CloseButton>
        </CloseButtonWrapper>


        {isPDF || isDoc ? (
          <iframe
          src={viewerURL}

            style={{
              width: "100%",
              height: "100%",
              border: "none",
              borderRadius: "5px",
            }}
          />
        ) : (
          <img
            src={img!}
            alt="Preview"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "5px",
            }}
          />
        )}

      
       
      </div>
    </Modal>
  );
}
